import { render, staticRenderFns } from "./koejakso-container.vue?vue&type=template&id=56eb138e&scoped=true&"
import script from "./koejakso-container.vue?vue&type=script&lang=ts&"
export * from "./koejakso-container.vue?vue&type=script&lang=ts&"
import style0 from "./koejakso-container.vue?vue&type=style&index=0&id=56eb138e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eb138e",
  null
  
)

export default component.exports